import React from "react";
import { SquareArrowUp, CircleArrowUp } from "lucide-react";

/**
 * Get icon for button widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getButtonIcon = (widget = null) => {
  const lucideIconProps = {
    size: 24,
    style: { paddingBottom: "2px" },
  };

  return <SquareArrowUp {...lucideIconProps} />;
};

/**
 * Get icon for generic widget patterns (fallback)
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getGenericWidgetIcon = (widget = null) => {
  const lucideIconProps = {
    size: 24,
    style: { paddingBottom: "2px" },
  };

  return <CircleArrowUp {...lucideIconProps} />;
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getButtonPatterns = () => {
  return ["Button"];
};
